/**
 * store.js
 *
 * This file sets up the global Redux store for the application using Redux Toolkit.
 * The store is the central place where the entire app's state is managed.
 * 
 * It combines multiple "slice reducers" into a single root reducer.
 * This store will be provided to the React app via <Provider> to allow any component
 * to access or update global state using Redux hooks (e.g., useSelector, useDispatch).
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/slices/authSlice'; // Manages login/logout and user session state.
import vendorReducer from '../redux/slices/vendorSlice'; // Manages vendor-specific state (e.g., store info, profile, etc.)
import listingsReducer from '../redux/slices/listingsSlice';
import recipesReducer from '../redux/slices/recipesSlice';
import batchesReducer from '../redux/slices/batchesSlice';
import notificationReducer from '../redux/slices/notificationSlice';
import ordersReducer from '../redux/slices/ordersSlice';
import notificationsReducer from '../redux/slices/notificationsSlice';
import supportReducer from '../redux/slices/supportSlice';

// Add slices which will be available in the global state here.
export const store = configureStore({
  reducer: {
    auth: authReducer, // Hold state returned by authReducer (e.g., state.auth)
    vendor: vendorReducer, // Hold state returned by vendorReducer (e.g., state.vendor)
    listings: listingsReducer,
    recipes: recipesReducer,
    batches: batchesReducer,
    notification: notificationReducer,
    orders: ordersReducer,
    notifications: notificationsReducer,
    support: supportReducer,
  },
});
